exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselet-dropdown.dropdown-menu[data-v-ba28c444] {\n    max-height: 50vh;\n    overflow-y: scroll;\n}\n.multiselect-tags-list .multiselect-input[data-v-ba28c444], .multiselect-tags-list .multiselect-single[data-v-ba28c444] {\n    padding: 4px;\n    font-size: 0.8rem;\n}\n.multiselect .multiselect-tags[data-v-ba28c444] {\n    min-height: auto;\n}\n", ""]);

// exports
